import { useDropzone } from "react-dropzone";
import { useState } from "react";

export default function MyDropzone({ handleAttachmentChange }) {
  const [files, setFiles] = useState([]);

  const onDrop = (acceptedFiles) => {
    const newFiles = [
      ...files,
      ...acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      ),
    ];
    setFiles(newFiles);

    // kirim kembali ke parent
    handleAttachmentChange(newFiles);
  };

  const removeFile = (name) => {
    const newFiles = files.filter((file) => file.name !== name);
    setFiles(newFiles);

    // update ke parent juga
    handleAttachmentChange(newFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });

  return (
    <div className="w-full">
      {/* Dropzone Area */}
      <div
        {...getRootProps()}
        className={`w-full border p-4 rounded text-center cursor-pointer 
          ${isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"}`}
      >
        <input {...getInputProps()} />
        <p className="text-gray-500">
          {isDragActive
            ? "Lepaskan file di sini ..."
            : "Tarik & letakkan file, atau klik untuk pilih"}
        </p>
      </div>

      {/* Preview */}
      {files.length > 0 && (
        <div className="mt-4 grid grid-cols-12 gap-3">
          {files.map((file) => (
            <div
              key={file.name}
              className="relative w-24 h-24 border rounded overflow-hidden group"
            >
              {/* Tombol Hapus */}
              <button
                type="button"
                onClick={() => removeFile(file.name)}
                className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded opacity-80 hover:opacity-100"
              >
                ✕
              </button>

              {/* Preview Gambar */}
              {file.type.startsWith("image/") ? (
                <img
                  src={file.preview}
                  alt={file.name}
                  className="object-cover w-full h-full"
                  onLoad={() => URL.revokeObjectURL(file.preview)}
                />
              ) : (
                <div className="flex items-center justify-center w-full h-full bg-gray-100 text-xs text-gray-600 p-2">
                  {file.name}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
